import R from 'ramda'

const SEND_FACEBOOK_BLAST_DISPLAY_TYPE = 'Send Facebook Blast'
const SEND_FACEBOOK_BLAST_TRIGGER_TYPE = 'SEND_FACEBOOK_BLAST'

const isSendFacebookBlastWidgetAction = R.propEq(
  'type',
  SEND_FACEBOOK_BLAST_TRIGGER_TYPE
)

const isPlainTextResponse = R.pipe(
  R.pathSatisfies(R.complement(R.either(R.isNil, R.isEmpty)), [
    'message',
    'message',
    'text'
  ])
)

const constructPlainTextResponseText = R.path(['message', 'message', 'text'])

const constructTemplateResponseText = R.pipe(
  R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'subtitle'
  ])
)

const constructPlainTextAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_BLAST_DISPLAY_TYPE),
  action: R.always('TEMPLATE_GENERIC'),
  blastText: constructPlainTextResponseText
})

const constructTemplateAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_BLAST_DISPLAY_TYPE),
  action: R.always('TEMPLATE_GENERIC'),
  blastText: constructTemplateResponseText,
  blastImageUrl: R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  blastTemplateTitle: R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  blastTemplateActionUrl: R.path([
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ])
})

const constructGenericTemplateAction = R.cond([
  [isPlainTextResponse, constructPlainTextAction],
  [R.T, constructTemplateAction]
])

const constructCustomTemplateAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_BLAST_DISPLAY_TYPE),
  customDmTemplate: R.pipe(R.prop('message'), JSON.stringify),
  action: R.always('TEMPLATE_CUSTOM')
})

const convertSendBlastWidgetActionToFormAction = R.cond([
  [R.has('isCustomTemplate'), constructCustomTemplateAction],
  [R.T, constructGenericTemplateAction]
])

export {
  isSendFacebookBlastWidgetAction,
  convertSendBlastWidgetActionToFormAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/send_facebook_blast.js